import { configureStore } from "@reduxjs/toolkit";
import { authSlice } from "./auth";
import { adminSlice } from "./admin";
import { chatsSlice } from "./chats";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    admin: adminSlice.reducer,
    chats: chatsSlice.reducer,
  },
});
